import type {
  DownloadBanner,
  GetLanguageLabel,
  MarketingBannerRow,
  MarketingBannersTranslations,
  RenameBannerHandlers,
} from "../types";

import { useIsMobile } from "../../hooks";
import { BannerPreviewDesktop } from "./Desktop";
import { BannerPreviewMobile } from "./Mobile";

type BannerPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  banner: MarketingBannerRow;
  translations: MarketingBannersTranslations;
  getLanguageLabel: GetLanguageLabel;
  /** Show a skeleton while banner data is being fetched. */
  isLoading?: boolean;
  /** Download handler for the mobile preview's "Download as PNG" action. */
  onDownload?: DownloadBanner;
  /** Fired before the "Copy HTML code" button writes to the clipboard. */
  onCopy?: () => void;
  /**
   * Hook bundle for inline rename inside the mobile bottom sheet.
   * When omitted, the rename action is hidden.
   */
  renameBanner?: RenameBannerHandlers;
  showLastClicked?: boolean;
  showCampaign?: boolean;
};

export const BannerPreviewModal = (props: BannerPreviewModalProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <BannerPreviewMobile {...props} />;
  }

  return <BannerPreviewDesktop {...props} />;
};
